export class UnifiedSchemaRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "dbName",
            "baseName": "dbName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableCount",
            "baseName": "tableCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<UnifiedTableRecord>",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DBResourceMetadata",
            "format": ""
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "DBSnapshotMetadata",
            "format": ""
        },
        {
            "name": "serverId",
            "baseName": "serverId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedSchemaRecord.attributeTypeMap;
    }
    constructor() {
    }
}
